import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_REMEDIATION_ACTIONS,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetRemediationActionsResponse, RemediationActionsPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { RemediationsWebComponent } from '../../../../remediations';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_REMEDIATION_ACTIONS)
export class GzRemediationActionsWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: RemediationActionsPayload;

  @query('#gzRemediationActions')
  private remediationActions: RemediationsWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getRemediationActions: function(request: GetWidgetDataRequest): Observable<GetRemediationActionsResponse> {
              return of(this.getPayload().remediationActions);
            }.bind(this)
          }
        }
      }
    };

    if (this.remediationActions) {
      if (!this.remediationActions.started) {
        this.remediationActions.injectDependencies(dependencies);
        this.remediationActions.start();
      } else {
        this.remediationActions.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-remediations id="gzRemediationActions"
                       data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                       data-targets=${JSON.stringify(this.payload?.targets)}
                       data-can-drill-down=${true}
                       data-display-mode=${getDisplayMode()}
      ></gz-remediations>`;
  }
}
